export const archiveAlertsBulkActionType = 'archiveAlerts';
